import React from "react";
import { PageIntro } from "../components/PageIntro";
import { SectionLabel } from "../components/SectionLabel";
import { AttributesBand } from "../components/AttributesBand";
import { ClosingCTA } from "../components/ClosingCTA";
import { audiences, notList, whatWeAre, workSteps } from "../data/brand";
import { photos } from "../data/photography";
export function About() {
  return <>
      <PageIntro label="About" title="A specialist firm for payroll operations and HR technology." image={photos.aboutFocus} imageCaption="Quiet competence. The work, done properly." data-id="element-670" data-mp="327rd5xopzbeo">
        <p className="mt-10 max-w-2xl text-lg leading-relaxed text-charcoal/80 md:text-xl" data-id="element-671" data-mp="2s9bmtwxio668">
          Constant runs payroll, implements and fixes the HR and payroll systems behind it, improves the processes
          around both, and steps in when something goes wrong. We’re built for organizations where getting this right
          matters too much to leave to chance.
        </p>
      </PageIntro>

      <section aria-label="What Constant is and isn’t" className="grid grid-cols-1 lg:grid-cols-2" data-id="element-672" data-mp="1uil3xi1osejg">
        <div className="bg-navy px-6 py-20 text-ivory md:px-10 md:py-28 lg:px-16" data-id="element-673" data-mp="1pk0b43orkx51">
          <div className="ml-auto max-w-[560px]" data-id="element-674" data-mp="23jj8c1g1eo2k">
            <p className="eyebrow text-ivory/75" data-id="element-675" data-mp="23g3u10u6tj27">What we are</p>
            <ul className="mt-8 border-t border-ivory/30" data-id="element-676" data-mp="1yhtw4ih2w4cw">
              {whatWeAre.map(s => <li key={s.title} className="border-b border-ivory/15 py-6" data-id="element-677" data-mp="2df332kiv7gpq">
                  <p className="font-display text-2xl md:text-3xl" data-id="element-678" data-mp="28gi22ivsgt08">{s.title}</p>
                  <p className="mt-2 text-[15px] text-ivory/70" data-id="element-679" data-mp="2m9hg0gfxaf5o">{s.line}</p>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="px-6 py-20 md:px-10 md:py-28 lg:px-16" data-id="element-680" data-mp="2i85wmsnn6q5x">
          <div className="max-w-[520px]" data-id="element-681" data-mp="2w86yobfn83mz">
            <SectionLabel data-id="element-682" data-mp="2w5178pjjkpo3">What we’re not</SectionLabel>
            <ul className="mt-8 border-t border-navy" data-id="element-683" data-mp="2r93s2mk0lpcw">
              {notList.map(item => <li key={item} className="border-b border-stone py-5 font-display text-2xl text-charcoal/60 line-through decoration-oxblood/70 decoration-1" data-id="element-684" data-mp="1ovo3w82sip82">
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      <section aria-labelledby="how-we-work" className="shell py-24 md:py-32" data-id="element-685" data-mp="22nceu81az7ng">
        <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-14" data-id="element-686" data-mp="27kckwiy5kaek">
          <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-687" data-mp="2cjpgpt704rta">
            <SectionLabel data-id="element-688" data-mp="2cmblxm6f6v8c">How we work</SectionLabel>
          </div>
          <div className="col-span-12 lg:col-span-9" data-id="element-689" data-mp="2gn3yaoal9g8u">
            <h2 id="how-we-work" className="font-display text-[clamp(2.25rem,4.6vw,4rem)] leading-[1.05] text-navy" data-id="element-690" data-mp="2lkndprj0vz2d">
              The same order, every time.
            </h2>
            <p className="mt-6 max-w-xl leading-relaxed text-charcoal/75" data-id="element-691" data-mp="ma5rieo3l1q9">
              Nothing gets redesigned until the next payroll is safe. Nothing gets handed back until it’s written down.
            </p>
          </div>
        </div>
        <ol className="grid grid-cols-1 border-t border-navy md:grid-cols-5" data-id="element-692" data-mp="ewd8y99rexb9">
          {workSteps.map((s, i) => <li key={s.name} className={`border-b border-stone py-8 md:border-b-0 md:py-10 md:pr-6 ${i > 0 ? "md:border-l md:pl-6" : ""}`} data-id="element-693" data-mp="9ylep8ln6z3w" data-mpi={i}>
              <span className="font-display text-lg tabular-nums text-oxblood" data-id="element-694" data-mp="12mhbedb7or0o">{s.number}</span>
              <h3 className="mt-4 font-display text-3xl text-navy" data-id="element-695" data-mp="xmmik47vlrcz">{s.name}</h3>
              <p className="mt-4 text-[15px] leading-relaxed text-charcoal/75" data-id="element-696" data-mp="snrsch7kx0iu">{s.line}</p>
            </li>)}
        </ol>
      </section>

      <AttributesBand data-id="element-697" data-mp="oloi1vwnc1z5" />

      <section aria-labelledby="audiences-title" className="shell py-24 md:py-32" data-id="element-698" data-mp="ooixta4psym8">
        <div className="grid grid-cols-12 gap-x-6 gap-y-10" data-id="element-699" data-mp="3dftu7lswdmvg">
          <div className="col-span-12 lg:col-span-4" data-id="element-700" data-mp="39cfg50oirgkn">
            <SectionLabel data-id="element-701" data-mp="39ert0zff70qu">Who we work with</SectionLabel>
            <h2 id="audiences-title" className="mt-6 font-display text-[clamp(2rem,3.6vw,3rem)] leading-[1.08] text-navy" data-id="element-702" data-mp="112xtkvdtmxtk">
              For the leaders who answer for payroll and HR systems.
            </h2>
          </div>
          <dl className="col-span-12 border-t border-navy lg:col-span-7 lg:col-start-6" data-id="element-703" data-mp="r7mf8e6brsmc">
            {audiences.map(a => <div key={a.role} className="grid grid-cols-1 gap-2 border-b border-stone py-6 md:grid-cols-7 md:gap-6" data-id="element-704" data-mp="1jugxr5jl0hx6">
                <dt className="font-display text-xl text-navy md:col-span-3" data-id="element-705" data-mp="1ou3aldvhzw5g">{a.role}</dt>
                <dd className="text-[15px] leading-relaxed text-charcoal/75 md:col-span-4" data-id="element-706" data-mp="1au29pyf8gopz">{a.need}</dd>
              </div>)}
          </dl>
        </div>
      </section>

      <section aria-label="Our promise" className="bg-oxblood" data-id="element-707" data-mp="1ex8d8yayo1sr">
        <div className="shell py-24 md:py-32" data-id="element-708" data-mp="3vj81kgbfivxs">
          <p className="eyebrow text-ivory/75" data-id="element-709" data-mp="3g8jrzcvngx5">Our promise</p>
          <p className="mt-10 max-w-5xl font-display text-[clamp(2rem,4.6vw,4.25rem)] italic leading-[1.1] text-ivory" data-id="element-710" data-mp="3hjqo81md4sh">
            We make payroll, systems, and process work — quietly, correctly, every time.
          </p>
        </div>
      </section>

      <ClosingCTA data-id="element-711" data-mp="5vf3ufqvf3kr" />
    </>;
}